
import PropTypes from 'prop-types';

import Container from '../../../Core/Container';

import { GalleryWrapper, ImgWrapper, GalleryImage } from './styles';

const StaticGallery = ({ data }) => {
  // * Null check for dataItem
  if (!data) return null;

  // * Destructure dataItem values
  const { imagesDam } = data;

  return (
    <Container>
      <GalleryWrapper>
        {imagesDam &&
          imagesDam.map(image => {
            return (
              <ImgWrapper key={image.id}>
                <GalleryImage
                  src={image}
                  alt={image.altText || ''}
                  objectFit="cover"
                />
              </ImgWrapper>
            );
          })}
      </GalleryWrapper>
    </Container>
  );
};

StaticGallery.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default StaticGallery;
